<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
            tiện ích</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <label>Tên:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Tên tiện ích..." v-model="search.cName" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <label>SĐT:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Số điện thoại..." v-model="search.cSoDienThoai" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <label>Địa chỉ:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Địa chỉ..." v-model="search.cDiaChi" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-select placeholder="Tất cả" v-model="search.nTinhTrang">
                  <el-option label="Tất cả" value="-1"></el-option>
                  <el-option label="Hoạt động" value="1"></el-option>
                  <el-option label="Đã xóa" value="0"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <label>Loại:</label>
            <div class="d-flex">

              <el-select placeholder="Tất cả" v-model="search.cLoai">
                <el-option label="Tất cả" value=""></el-option>
                <el-option label="Quầy thuốc" value="Quầy thuốc"></el-option>
                <el-option label="Cây xăng" value="Cây xăng"></el-option>
                <el-option label="Nhà nghỉ" value="Nhà nghỉ"></el-option>
              </el-select>

              <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage" class="ms-2"><i
                  class="fa fa-search"></i></el-button>

            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function">
          <div class="col-md-6">
            <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd" data-bs-toggle="modal"
              data-bs-target="#modal_util">
              <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
              <span class="btn-inner--text">&nbsp;Thêm tiện ích</span>
            </el-button>
          </div>
          <!-- <div class="col-md-6" style="text-align:right">
              <el-button plain icon="el-icon-refresh"  style="margin-right:30px" title="Đồng bộ" type="warning" @click=""
                v-loading.fullscreen.lock="isLoading"></el-button>
            </div> -->
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" height="100%" fit
            stripe highlight-current-row>
            <el-table-column prop="nMa" label="Mã" width="70" align="center"></el-table-column>
            <el-table-column prop="cName" label="Tên tiện ích" header-align="center" min-width="150">
            </el-table-column>
            <el-table-column prop="cDiaChi" label="Địa chỉ" header-align="center" min-width="150">
              <!-- <template #default="scope">
              {{ scope.row.cDiaChi }}
            </template> -->
            </el-table-column>
            <el-table-column prop="cSoDienThoai" label="SĐT" width="100" align="center"></el-table-column>
            <el-table-column prop="cLoai" label="Loại" width="120" align="center">
              <!--  <template #default="scope">
                <el-tag type="success" v-if="scope.row.cLoai == 1" size="small">Ăn uống</el-tag>
                <el-tag type="danger" v-if="scope.row.cLoai == 2" size="small">Giải trí</el-tag>
              </template> -->
            </el-table-column>
            <el-table-column prop="dNgayTao" label="Ngày tạo" width="120" align="center">
              <template #default="scope">
                <span v-if="scope.row.dNgayTao">{{
                  momentDate(scope.row.dNgayTao)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="nTinhTrang" label="Trạng thái" width="120" align="center">
              <template #default="scope">
                <el-tag type="success" v-if="scope.row.nTinhTrang == 1" size="small">Hoạt Động</el-tag>
                <el-tag type="danger" v-if="scope.row.nTinhTrang == 0" size="small">Đã xóa</el-tag>
              </template>
            </el-table-column>
            <!-- Button hành động -->
            <el-table-column width="150" align="center" label="Hành động">
              <template #default="scope">

                <el-button plain type="primary" :disabled="scope.row.nTinhTrang == 0" @click="handleOpenEdit(scope.row)"
                  data-bs-toggle="modal" data-bs-target="#modal_util">
                  <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                </el-button>

                <el-button plain type="danger" :disabled="scope.row.nTinhTrang == 0"
                  v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>

    <div class="modal fade" id="modal_util" ref="utilModalRef" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-650px">
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header" id="modal_util_header">
            <!--begin::Modal title-->
            <h2 class="fw-bolder">{{ !operation ? "Thêm tiện ích" : "Cập nhật tiện ích" }}</h2>
            <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" @click="handleClose">
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <div class="modal-body">
            <el-form :model="formData" :rules="rules" ref="formData" label-width="150px" class="d-flex flex-column ">
              <el-form-item label="Tên tiện ích" prop="cName">
                <el-input v-model="formData.cName" />
              </el-form-item>
              <el-form-item label="Loại tiện ích" prop="cLoai">
                <el-select placeholder="Chọn loại tiện ích" v-model="formData.cLoai" style="width: 30%;">
                  <el-option label="Quầy thuốc" value="Quầy thuốc"></el-option>
                  <el-option label="Cây xăng" value="Cây xăng"></el-option>
                  <el-option label="Nhà nghỉ" value="Nhà nghỉ"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Số điện thoại" prop="cSoDienThoai">
                <el-input v-model="formData.cSoDienThoai" />
              </el-form-item>
              <el-form-item label="Địa chỉ" prop="cDiaChi">
                <el-input v-model="formData.cDiaChi" />
              </el-form-item>
              <el-form-item label="Kinh độ" prop="nKinhDo">
                <el-input v-model="formData.nKinhDo" />
              </el-form-item>
              <el-form-item label="Vĩ độ" prop="nViDo">
                <el-input v-model="formData.nViDo" />
              </el-form-item>
              <el-form-item label="Hình ảnh" prop="imageFile">
                <el-upload action="#" list-type="picture-card" :auto-upload="false" placeholder="Chọn hình ảnh"  accept="image/*"
                  ref="upload" :file-list="imageFile" :on-change="handleChangeFile" :on-remove="handleRemoveFile">
                  <div class="d-flex align-items-center justify-content-center w-100 h-100">
                    <i class="el-icon-plus" v-if="imageFile.length == 0"></i>
                    <i class="el-icon-refresh" v-if="imageFile.length > 0"></i>
                  </div>
                </el-upload>
              </el-form-item>

            </el-form>
          </div>
          <div class="modal-footer">
            <div class="btn-group">
              <el-button plain v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Thêm</el-button>
              <el-button plain v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Lưu</el-button>
              <el-button plain type="danger" @click="handleClose">Thoát</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Utilities } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import { baseUrl } from "@/utils/global";
import { ElMessage } from "element-plus";
export default {
  name: 'utilities',
  data() {
    return {
      search: {
        cName: "",
        cSoDienThoai: "",
        cDiaChi: "",
        cLoai: "",
        nTinhTrang: "-1",
      },
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      formData: {
        cName: "",
        cUrl: "",
        cLoai: "",
        cSoDienThoai: "",
        cDiaChi: "",
        nKinhDo: "",
        nViDo: "",
        cHinhAnhUrl: "",
        imageFile: [],
      },
      rules: {
        cName: [{ required: true, message: "Xin vui lòng điền tên tiện ích", trigger: "blur" }],
        cLoai: [{ required: true, message: "Xin vui lòng chọn loại", trigger: "blur" }],
        cSoDienThoai: [
          { required: true, message: "Xin vui lòng điền số điện thoại", trigger: "blur" },
          { min: 10, message: "Xin vui lòng điền ít nhất 10 số", trigger: "blur" },
          //{ type: 'number', message: "Xin vui lòng chỉ điền chữ số", trigger: "blur" }
        ],
        cDiaChi: [{ required: true, message: "Xin vui lòng điền địa chỉ", trigger: "blur" }],
        nKinhDo: [{ required: true, message: "Xin vui lòng điền kinh độ", trigger: "blur" }],
        nViDo: [{ required: true, message: "Xin vui lòng điền vĩ độ", trigger: "blur" }],
      },
      tableData: {
        content: []
      },
      isLoading: false,
      modalVisible: false,
      operation: false,
      isSearchLoading: false,
      imageFile: [],
      store: useStore(),
      baseUrl:baseUrl
    }
  },
  watch: {
    modalVisible() {
      if (!this.modalVisible) {
        this.imageFile = []
      }
    }
  },
  methods: {
    handleChangePageNum(val) {
      this.pageRequest.pageNum = val
      this.handleFindPage()
    },
    handleChangePageSize(val) {
      this.pageRequest.pageSize = val
      this.handleFindPage()
    },
    handleOpenAdd() {
      this.$refs.formData.resetFields()
      this.imageFile = []
      this.modalVisible = true
      this.operation = false
      this.formData = {}
    },
    handleOpenEdit(val) {
      this.$refs.formData.resetFields()
      this.imageFile = []
      this.modalVisible = true
      this.operation = true
      this.formData = Object.assign({}, val)
      if (val.cHinhAnhUrl) {
        this.addImageFromURL(baseUrl + val.cHinhAnhUrl)
      }
    },
    handleSave() {
      this.$refs.formData.validate((valid) => {
        if (valid)
          this.$confirm("Bạn có muốn lưu tiện ích này không?", "Xác nhận", {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy",
            type: "warning",
          })
            .then(() => {
              const formData = new FormData();
              const data = {
                "cName": this.formData.cName,
                "cSoDienThoai": this.formData.cSoDienThoai,
                "nViDo": this.formData.nViDo,
                "nKinhDo": this.formData.nKinhDo,
                "cHinhAnhUrl": "url",
                "cDiaChi": this.formData.cDiaChi,
                "cLoai": this.formData.cLoai,
                "nTinhTrang": 1
              }
              if (this.imageFile.length > 0) {
                if (this.imageFile[0].status == "ready") {
                  formData.append('image', this.imageFile[0].raw)
                }
              }
              if (this.operation) {
                data.nMa = this.formData.nMa
                formData.append('utilityRequest', new Blob([JSON.stringify(data)], { type: "application/json" }))
                this.store.dispatch(Utilities.updateUtilities, { formData: formData, id: this.formData.nMa }).then(res => {
                  if (res.code == 200) {
                    ElMessage({ message: "Cập nhật tiện ích thành công", type: "success" });
                    this.handleClose()
                    this.handleFindPage()
                  }
                  else {
                    ElMessage({ message: res.msg, type: "error" });
                  }
                }).catch((error) => {
                  ElMessage({ message: "Cập nhật tiện ích thất bại", type: "error" });
                })
              } else {
                formData.append('utilityRequest', new Blob([JSON.stringify(data)], { type: "application/json" }))
                this.store.dispatch(Utilities.saveUtilities, formData).then(res => {
                  if (res.code == 200) {
                    ElMessage({ message: "Thêm tiện ích thành công", type: "success" });
                    this.handleClose()
                    this.handleFindPage()
                  }
                  else {
                    ElMessage({ message: res.msg, type: "error" });
                  }
                }).catch((error) => {
                  ElMessage({ message: "Thêm tiện ích thất bại", type: "error" });
                })
              }
            })
      })

    },
    handleClose() {
      this.$refs.formData.resetFields()
      this.modalVisible = false
      hideModal(this.$refs.utilModalRef)
    },
    handleDelete(val) {
      this.$confirm("Bạn có muốn xóa tiện ích này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.store.dispatch(Utilities.deleteUtilitiesById, val.nMa).then(res => {
            if (res.code == 200) {
              ElMessage({ message: "Xóa tiện ích thành công", type: "success" });
              this.handleFindPage()
            } else {
              ElMessage({ message: res.msg, type: "error" });
            }
          }).catch((error) => {
            ElMessage({ message: "Xóa tiện ích thất bại", type: "error" });
          })

        })
    },
    handleFindPage() {
      this.pageRequest.columnFilters = {
        cName: { value: this.search.cName },
        cSoDienThoai: { value: this.search.cSoDienThoai },
        cDiaChi: { value: this.search.cDiaChi },
        cLoai: { value: this.search.cLoai },
        nTinhTrang: { value: this.search.nTinhTrang }
      }
      this.store.dispatch(Utilities.findPageUtilities, this.pageRequest).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
        }
      }).catch((error) => {
        ElMessage({ message: "Tìm kiếm tiện ích thất bại", type: "error" });
      })
    },
    async handleChangeFile(file, fileList) {
      this.imageFile = [file]
      this.formData.imageFile = this.imageFile
      this.formData.cHinhAnhUrl = file.name
    },
    handleRemoveFile(file, fileList) {
      this.imageFile = []
      this.formData.imageFile = this.imageFile
      this.formData.cHinhAnhUrl = null
    },
    addImageFromURL(url) {
      fetch(url)
        .then(res => res.blob())
        .then(blob => {
          const file = new File([blob], "image.jpg", { type: blob.type });
          this.imageFile.push({
            name: file.name,
            url: URL.createObjectURL(file),
            status: 'success',
            uid: Date.now(),
            raw: file
          });
        });
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    }
  },
  mounted() {
    this.handleFindPage()
  }
};
</script>
<style lang="scss"></style>